"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var classnames_1 = require("../util/classnames");
var header_1 = require("./header");
var footer_1 = require("./footer");
var localizers_1 = require("../util/localizers");
var CustomPropTypes = require("../util/custom-prop-types");
var dates = require("../util/dates");
var dateMath = require("../util/date-arithmetic");
var constants = require("./constants");
var _1 = require("../util/_");
var widget_helpers_1 = require("../util/widget-helpers");
var timeout_manager_1 = require("../util/timeout-manager");
var focus_mixin_1 = require("../mixins/focus-mixin");
var vdl_prefix_1 = require("../util/vdl-prefix");
var calendar_view_1 = require("./calendar-view");
var dir = constants.directions;
var values = function (obj) { return Object.keys(obj).map(function (k) { return obj[k]; }); };
var invert = function (obj) { return _1.transform(obj, function (o, val, key) {
    o[val] = key;
}, {}); };
var views = constants.calendarViews;
var VIEW_OPTIONS = values(views);
var ALT_VIEW = invert(constants.calendarViewHierarchy);
var NEXT_VIEW = constants.calendarViewHierarchy;
var VIEW_UNIT = constants.calendarViewUnits;
var ARROWS_TO_DIRECTION = {
    ArrowDown: dir.DOWN,
    ArrowUp: dir.UP,
    ArrowRight: dir.RIGHT,
    ArrowLeft: dir.LEFT
};
var MULTIPLIER = (_a = {},
    _a[views.YEAR] = 1,
    _a[views.DECADE] = 10,
    _a[views.CENTURY] = 100,
    _a);
var format = function (props, f) { return localizers_1.date.getFormat(f, props[f + 'Format']); };
function dateOrNull(dt) {
    if (dt && !isNaN(dt.getTime())) {
        return dt;
    }
    return null;
}
function localizedMessage(messageKey, locale) {
    return localizers_1.message.formatMessage('adp-react-components/calendar/' + messageKey, undefined, locale);
}
function msgs(msgs, locale) {
    return Object.assign({
        moveBack: localizedMessage('MOVE_BACK', locale),
        moveForward: localizedMessage('MOVE_FORWARD', locale)
    }, msgs);
}
function viewValue(date, view) {
    switch (view) {
        case 'month':
            return dateMath.getMonth(date);
        case 'year':
            return dateMath.getYear(date);
        case 'decade':
            return dateMath.getDecade(date);
        case 'century':
            return dateMath.getCentury(date);
    }
    return undefined;
}
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._timeoutManager = new timeout_manager_1.TimeoutManager();
        _this._isMounted = false;
        _this.state = {
            selectedIndex: 0,
            view: _this.props.initialView || 'month'
        };
        _this.setTimeout = function (key, callback, duration) {
            if (_this._isMounted) {
                return _this._timeoutManager.setTimeout(key, callback, duration);
            }
        };
        _this.handleBlur = function (event) {
            focus_mixin_1.handleBlur(_this, event, undefined, function () {
                var _a;
                if (+((_a = _this.props) === null || _a === void 0 ? void 0 : _a.tabIndex) === -1) {
                    return false;
                }
            });
        };
        _this.handleFocus = function (event) {
            focus_mixin_1.handleFocus(_this, event, undefined, function () {
                var _a;
                if (+((_a = _this.props) === null || _a === void 0 ? void 0 : _a.tabIndex) === -1) {
                    return false;
                }
            });
        };
        //FIXME @widgetEditable
        _this.navigate = function (direction, date) {
            var view = _this.state.view;
            if (!date) {
                date = [dir.LEFT, dir.RIGHT].indexOf(direction) !== -1 ? _this.nextDate(direction) : _this.props.currentDate;
            }
            if (direction === dir.DOWN) {
                view = ALT_VIEW[view] || view;
            }
            if (direction === dir.UP) {
                view = NEXT_VIEW[view] || view;
            }
            if (_this.isValidView(view) && date !== undefined && dateMath.inRange(date, _this.props.min, _this.props.max, view)) {
                widget_helpers_1.notify(_this.props.onNavigate, [date, view]);
                _this.focus();
                _this.changeCurrentDate(date);
                _this.setState({
                    view: view
                });
            }
        };
        _this.focus = function () {
            var _a;
            if (+((_a = _this.props) === null || _a === void 0 ? void 0 : _a.tabIndex) > -1) {
                ReactDOM.findDOMNode(_this).focus();
            }
        };
        //FIXME @widgetEditable
        _this.change = function (date) {
            if (_this.state.view === _this.props.initialView) {
                _this.changeCurrentDate(date);
                widget_helpers_1.notify(_this.props.onChange, date);
                _this.focus();
                return;
            }
            _this.navigate(dir.DOWN, date);
        };
        //FIXME @widgetEditable
        _this.changeCurrentDate = function (date, currentDate) {
            if (currentDate === undefined) {
                currentDate = _this.props.currentDate;
            }
            var inRangeDate = _this.inRangeValue(date ? new Date(date) : currentDate);
            if (dateMath.eq(inRangeDate, dateOrNull(currentDate), VIEW_UNIT[_this.state.view])) {
                return;
            }
            widget_helpers_1.notify(_this.props.onCurrentDateChange, inRangeDate);
        };
        //FIXME @widgetEditable
        _this.select = function (date) {
            var view = _this.props.initialView;
            widget_helpers_1.notify(_this.props.onChange, date);
            if (_this.isValidView(view) && dateMath.inRange(date, _this.props.min, _this.props.max, view)) {
                _this.focus();
                _this.changeCurrentDate(date);
                _this.setState({
                    view: view
                });
            }
        };
        _this.nextDate = function (direction) {
            var dirIndicator = direction === dir.LEFT ? -1 : 1;
            var view = _this.state.view;
            var unit = view === views.MONTH ? view : views.YEAR;
            var multi = MULTIPLIER[view] || 1;
            return dateMath.add(_this.props.currentDate, multi * dirIndicator, unit);
        };
        //FIXME @widgetEditable
        _this._keyDown = function (e) {
            var ctrl = e.ctrlKey;
            var key = e.key;
            var direction = ARROWS_TO_DIRECTION[key];
            var min = _this.props.min;
            var max = _this.props.max;
            var currentDate = _this.props.currentDate;
            var view = _this.state.view;
            var unit = VIEW_UNIT[view];
            var current = currentDate;
            if (key === 'Enter') {
                e.preventDefault();
                return _this.change(current);
            }
            if (direction) {
                if (ctrl) {
                    e.preventDefault();
                    _this.navigate(direction);
                }
                else {
                    current = dates.move(currentDate, min, max, view, direction);
                    if (!dateMath.eq(current, currentDate, unit)) {
                        e.preventDefault();
                        if (dateMath.gt(currentDate, current, view)) {
                            _this.navigate(dir.RIGHT, currentDate);
                        }
                        else if (dateMath.lt(currentDate, current, view)) {
                            _this.navigate(dir.LEFT, currentDate);
                        }
                        else {
                            _this.changeCurrentDate(currentDate);
                        }
                    }
                }
            }
            widget_helpers_1.notify(_this.props.onKeyDown, [e]);
        };
        _this._label = function () {
            var locale = _this.props.locale;
            var view = _this.state.view;
            var dt = _this.props.currentDate;
            var props = _1.omit(_this.props, ['locale']);
            if (view === 'month') {
                return localizers_1.date.format(dt, format(props, 'header'), locale);
            }
            else if (view === 'year') {
                return localizers_1.date.format(dt, format(props, 'year'), locale);
            }
            else if (view === 'decade') {
                return localizers_1.date.format(dateMath.startOf(dt, 'decade'), format(props, 'decade'), locale);
            }
            else if (view === 'century') {
                return localizers_1.date.format(dateMath.startOf(dt, 'century'), format(props, 'century'), locale);
            }
        };
        _this.inRangeValue = function (_value) {
            var value = dateOrNull(_value);
            var min = _this.props.min;
            var max = _this.props.max;
            if (value === null) {
                return value;
            }
            return dateMath.max(dateMath.min(value, max), min);
        };
        _this.isValidView = function (next) {
            var bottom = VIEW_OPTIONS.indexOf(_this.props.initialView);
            var top = VIEW_OPTIONS.indexOf(_this.props.finalView);
            var current = VIEW_OPTIONS.indexOf(next);
            return current >= bottom && current <= top;
        };
        return _this;
    }
    Calendar.prototype.componentWillMount = function () {
        this.changeCurrentDate(this.props.value);
    };
    Calendar.prototype.componentWillReceiveProps = function (nextProps) {
        var bottom = VIEW_OPTIONS.indexOf(nextProps.initialView);
        var top = VIEW_OPTIONS.indexOf(nextProps.finalView);
        var current = VIEW_OPTIONS.indexOf(this.state.view);
        var view = this.state.view;
        var val = this.inRangeValue(nextProps.value);
        if (current < bottom) {
            this.setState({ view: view = nextProps.initialView });
        }
        else if (current > top) {
            this.setState({ view: view = nextProps.finalView });
        }
        // if the value changes reset views to the new one
        if (!dateMath.eq(val, dateOrNull(this.props.value), VIEW_UNIT[view])) {
            this.changeCurrentDate(val, nextProps.currentDate);
        }
    };
    Calendar.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    Calendar.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        this._timeoutManager.clearAllTimeouts();
    };
    Calendar.prototype.render = function () {
        var _a;
        var min = this.props.min;
        var max = this.props.max;
        var blacklistDates = this.props.blacklistDates;
        var currentDate = this.props.currentDate;
        var _b = this.props, className = _b.className, value = _b.value, footerFormat = _b.footerFormat, disabled = _b.disabled, readOnly = _b.readOnly, finalView = _b.finalView, footer = _b.footer, locale = _b.locale;
        var _c = this.state, view = _c.view, focused = _c.focused;
        var todaysDate = new Date();
        var todayNotInRange = !dateMath.inRange(todaysDate, min, max, view);
        var viewID = widget_helpers_1.instanceId(this, '_calendar');
        var labelID = widget_helpers_1.instanceId(this, '_calendar_label');
        var key = view + '_' + viewValue(currentDate, view);
        var elementProps = _1.omit(this.props, Object.keys(Calendar.propTypes));
        var viewProps = _1.pick(this.props, Object.keys(calendar_view_1.CalendarView.propTypes));
        var isDisabled = disabled || readOnly;
        var messages = msgs(this.props.messages, locale);
        var calendarClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('calendar')] = true,
            _a[vdl_prefix_1.vdlPrefix('calendar--focus')] = !!focused,
            _a[vdl_prefix_1.vdlPrefix('calendar--disabled')] = disabled,
            _a[vdl_prefix_1.vdlPrefix('calendar--readonly')] = readOnly,
            _a);
        return (React.createElement("div", __assign({}, elementProps, { role: "group", onKeyDown: this._keyDown, onBlur: this.handleBlur, onFocus: this.handleFocus, className: classnames_1.classNames(className, calendarClasses) }),
            React.createElement(header_1.Header, { label: this._label(), labelId: labelID, messages: messages, upDisabled: isDisabled || view === finalView, prevDisabled: isDisabled || !dateMath.inRange(this.nextDate(dir.LEFT), min, max, view), nextDisabled: isDisabled || !dateMath.inRange(this.nextDate(dir.RIGHT), min, max, view), onViewChange: this.navigate.bind(null, dir.UP, null), onMoveLeft: this.navigate.bind(null, dir.LEFT, null), onMoveRight: this.navigate.bind(null, dir.RIGHT, null) }),
            React.createElement(calendar_view_1.CalendarView, __assign({}, viewProps, { calendarView: view, tabIndex: -1, key: key, id: viewID, min: min, max: max, blacklistDates: blacklistDates, className: vdl_prefix_1.vdlPrefix('calendar__grid'), "aria-labelledby": labelID, today: todaysDate, value: value, focused: currentDate, onChange: this.change, onKeyDown: this._keyDown })),
            footer &&
                React.createElement(footer_1.Footer, { value: todaysDate, format: footerFormat, locale: locale, disabled: disabled || todayNotInRange, readOnly: readOnly, onClick: this.select })));
    };
    Calendar.propTypes = {
        disabled: CustomPropTypes.disabled,
        readOnly: CustomPropTypes.readOnly,
        onChange: PropTypes.func,
        value: PropTypes.instanceOf(Date),
        min: PropTypes.instanceOf(Date),
        max: PropTypes.instanceOf(Date),
        blacklistDates: PropTypes.any,
        currentDate: PropTypes.instanceOf(Date),
        onCurrentDateChange: PropTypes.func,
        duration: PropTypes.number,
        initialView: PropTypes.oneOf(VIEW_OPTIONS),
        finalView: function (props, propname, componentName) {
            var rest = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                rest[_i - 3] = arguments[_i];
            }
            var err = PropTypes.oneOf(VIEW_OPTIONS).apply(void 0, __spreadArrays([props, propname, componentName], rest));
            if (err) {
                return err;
            }
            if (VIEW_OPTIONS.indexOf(props[propname]) < VIEW_OPTIONS.indexOf(props.initialView)) {
                return new Error(("The `" + propname + "` prop: `" + props[propname] + "` cannot be 'lower' than the `initialView`\n          prop. This creates a range that cannot be rendered.").replace(/\n\t/g, ''));
            }
        },
        onNavigate: PropTypes.func,
        locale: PropTypes.string,
        footer: PropTypes.bool,
        dayComponent: CustomPropTypes.elementType,
        headerFormat: PropTypes.any,
        footerFormat: PropTypes.any,
        dayFormat: PropTypes.any,
        dateFormat: PropTypes.any,
        monthFormat: PropTypes.any,
        yearFormat: PropTypes.any,
        decadeFormat: PropTypes.any,
        centuryFormat: PropTypes.any,
        messages: PropTypes.shape({
            moveBack: PropTypes.string,
            moveForward: PropTypes.string
        }),
        tabIndex: PropTypes.number,
        onKeyDown: PropTypes.func,
        className: PropTypes.string,
        onAriaActiveDescendant: PropTypes.func
    };
    Calendar.defaultProps = {
        value: undefined,
        min: new Date(1900, 0, 1),
        max: new Date(2099, 11, 31),
        currentDate: new Date(),
        initialView: 'month',
        finalView: 'century',
        tabIndex: 0,
        footer: false
    };
    return Calendar;
}(React.PureComponent));
exports.Calendar = Calendar;
